import { createContext, useContext } from "react";

export const DateRangeContext = createContext();
export const SearchBarContext = createContext();
export const ChartExpandStateContext = createContext();
export const DisplayedCikContext = createContext();
export const CompanyNameContext = createContext();
export const ExchangeNameContext = createContext();
export const SelectedDatapointContext = createContext();
export const SelectedTimeSeriesContext = createContext();
export const OnboardingWizardContext = createContext();

export const SelectedTableSeriesContext = createContext();
export const TableSeriesExpandStateContext = createContext();

export const SubMenuContext = createContext();

// Subscription status context - use undefined as default to enable error checking
export const SubscriptionStatusContext = createContext(undefined);

// Custom hook with proper error checking - this is the recommended way to consume the context
export function useSubscriptionStatus() {
    const context = useContext(SubscriptionStatusContext);
    
    // If context is undefined, the component is not wrapped in a provider
    // This gives a clear, actionable error message
    if (context === undefined) {
        throw new Error(
            'useSubscriptionStatus must be used within a SubscriptionStatusContext.Provider. ' +
            'Make sure your component is rendered within the App component tree.'
        );
    }
    
    return context;
}